import React, { useState } from 'react';
import axios from 'axios';
import './SearchBar.css';
import PropTypes from 'prop-types';
import {ImSearch} from 'react-icons/im'
import config from '../../config';
import Popup from '../popup/Popup';

export default function SearchBar({ onSearch, searchStarted }) {
  const [query, setQuery] = useState('');

  const [isFocused, setIsFocused] = useState(false);
  const [showPopup, setShowPopup] = useState(false);
  const [popupMessage, setPopupMessage] = useState('');

  const popupStatus = async (message) => {
    setPopupMessage(message);
    setShowPopup(true);
  }

  const handleQueryChange = (event) => {
    setQuery(event.target.value);
  };

  const inappropriateKeywords = ['porn', 'sex', 'nude', 'explicit', 'adult', 'xxx', "penis", "vagina", "tits", "boobs", "gay", "lesbian", "bisexual", "trans", "transexual", "dick", "cock", "ballsack", "butthole", "asshole", "fuck", "shit", "piss", "bitch", "bbc"]; 

  const handleSubmit = async (event) => {
    event.preventDefault();
    try {
      searchStarted();
      const queryLower = query.toLowerCase();
      if(inappropriateKeywords.some(keyword => queryLower.includes(keyword))){
        throw new Error("Haha noo...");
      }
      const response = await axios.get(`${config.apiUrl}/api/products/search`, {
        params: {
          q: query,
        },
      });
      
      // Check if the response was successful
      if (response.status !== 200) {
        throw new Error(response.data.message || 'An error occurred');
      }
  
      const items = response.data;
      onSearch(items);
    } catch (error) {
      // Handle both axios errors and our thrown errors
      let errorMessage = '';
      if (error.response) {
        // The request was made and the server responded with a status code
        // that falls out of the range of 2xx
        errorMessage = error.response.data.message || 'An error occurred';
      } else if (error.message) {
        // This is for the error we threw manually
        errorMessage = error.message;
      } else {
        // Any other unexpected errors
        errorMessage = 'An unexpected error occurred';
      }
      
      await popupStatus(errorMessage, "Close");
    }
  };
  

  return (
    <form className='searchbar-container' onSubmit={handleSubmit}>
      <Popup isPopupOpen={showPopup} message={popupMessage} button1Text="Close" button1Action={() => setShowPopup(false)} />
      <div className="search-bar-and-icon-container">
        <input type="text"  
        className='searchbar-input'
        value={query} 
        onChange={handleQueryChange} 
        placeholder="Search for an item..."
        onFocus={() => setIsFocused(true)}
        onBlur={() => setIsFocused(false)}
        />
        <ImSearch 
          className={`search-icon ${isFocused ? 'focused' : ''}`} 
          type="submit"
          onClick={handleSubmit}
        />

      </div>
    </form>
  );
}

SearchBar.propTypes = {
  onSearch: PropTypes.func.isRequired,
  searchStarted: PropTypes.func,
  // setIsLoading: PropTypes.func
};